<template>
  <div>
    <main-navbar
      :name="currentUserName"
      :location="currentLocation"
      @on-logout="onLogoutRequest"
      @on-cash_out="onCashOut"/>

      <router-view />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import MainNavbar from "../components/pos/MainNavbar"
export default {
  components: {
    MainNavbar
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("general", ["user_subsidiary"]),
    currentUserName() {
      if (this.user) {
        return this.user.meta_info.name + " " + this.user.meta_info.last_name;
      }
      return null
    },
    currentLocation() {
      if (this.user && this.user_subsidiary) {
        return this.user_subsidiary.subsidiary_name
      }
      return null
    }
  },
  methods: {
    ...mapMutations("auth", ["cleanSession"]),
    ...mapMutations("general", ["cleanSubsidiariesInfo"]),
    ...mapGetters("general", ["getSubsidiaries"]),
    async onCashOut(){
      alert("onCashOut")
      // Encontramos información de sucursal
      let user_subsidiary = this.getSubsidiaries().find(f => f.subsidiary_id = this.user.meta_info.subsidiary_id)
    },
    async onLogoutRequest(){
      await this.doLogout()
    },
    async doLogout(){
      this.cleanSubsidiariesInfo();
      this.cleanSession();
      await this.$router.replace({name: 'login'});
    }
  },
};
</script>

<style>
 .main-app-container {
   height: auto;
 }
</style>